import { idText } from "typescript";

export interface IPayroll {
  payrollId: number;
  basic: number;
  earned_Basic: number;
  hra: number;
  earned_HRA: number;
  conveyance_Allowance: number;
  earned_Conveyance_Allowance: number;
  employee_PF: number;
  employer_PF: number;
  esic_Employee: number;
  esic_Employer: number;
  health_Insurance_Amount: number;
  meal_Allowance_Amount: number;
  transport_Allowance_Amount: number;
  tds: number;
  otherEarning: number;
  otherDeduction: number;
  totalEarnings: number;
  totalDeductions: number;
  netSalary: number;
  incentive: number;
  absentDays: number;
  halfDays: number;
  paidDays: number;
  lop: number;
  entitled: number;
  totalDaysInMonth: number;
  payrollMonth: string;
  status?: 'pending' | 'generated' | 'updated' | 'released' | 'hold';
  comment?: string;
}

export interface IEmployeePayroll extends IPayroll {
  year: number;
  month: number;
  employeeId: number;
  employeeName: string;
  email?: string;
  pan?: string;
  uan?: string;
  companyId?: number;
  branchId?: number;
  departmentId?: number;
  departmentName?: string;
  employeeCode?: string;
  balance_Leave?: number;
  entitlement?: number;
}

export interface IPayrollData {
  data: IEmployeePayroll[];
  totalCount: number;
  loading: boolean;
}
type PayrollStatus = 'pending' | 'generated' | 'updated' | 'released' | 'hold';
export interface IPayrollFilter {
  year: number;
  month: number;
  employeeName?: string;
  companyId?: number;
  payrollCompanyId?: number;
  branchId?: number;
  departmentId?: number;
  status?: PayrollStatus;
}
const now = new Date();
const prevMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
export const emptyFilter: IPayrollFilter = {
  year: prevMonthDate.getFullYear(),
  month: prevMonthDate.getMonth() + 1
}
export interface CellEditResponce {
  payrollId: number,
  field: string,
  value: number,
  totalEarnings: number,
  totalDeductions: number,
  netSalary: number,
  status: PayrollStatus
}
export interface IStatusCount {
  status: string,
  count: number
}
export const headers = [
  { id: 1, name: "EmpCode" },
  { id: 2, name: "Employee Name(Dep)" },
  { id: 3, name: "Basic" },
  { id: 4, name: "E_Basic" },
  { id: 5, name: "HRA" },
  { id: 6, name: "E_HRA" },
  { id: 7, name: "Conv" },
  { id: 8, name: "E_Conv" },
  { id: 9, name: "Incentive" },
  { id: 10, name: "OtherEarn" },
  { id: 11, name: "EmPF" },
  { id: 12, name: "ErPF" },
  { id: 13, name: "EmESIC" },
  { id: 14, name: "ErESIC" },
  { id: 15, name: "Health" },
  { id: 16, name: "Meal" },
  { id: 17, name: "Transport" },
  { id: 18, name: "TDS" },
  { id: 19, name: "OtherDedu" },
  { id: 20, name: "NetSalary" },
  { id: 21, name: "TP" },
  { id: 22, name: "TA" },
  { id: 23, name: "BL" },
  { id: 24, name: "EN" },
  { id: 25, name: "LOP" },
  { id: 26, name: "PD" },
  { id: 27, name: "S" },
];
